import { MerchService } from './merch.service';

export const services: any[] = [
	MerchService,
];

export * from './merch.service';
